import dayjs from 'dayjs'
import type { EncounterLabApiItem } from 'features/Procedure/state/procedure-api.type'
import { LabSelect } from './components/lab-select/lab-select'

type ColumnsParams = {
  selectedLabId: number | null
  onSelectLab: (lab: EncounterLabApiItem) => void
}

export const labsTableColumns = ({ selectedLabId, onSelectLab }: ColumnsParams) => [
  {
    title: 'Lab test',
    dataIndex: 'select',
    key: 'select',
    ellipsis: false,
    render: (_: string, lab: EncounterLabApiItem) => {
      return <LabSelect lab={lab} selectedLabId={selectedLabId} onSelect={onSelectLab} />
    },
  },
  {
    title: 'Date of lab',
    dataIndex: 'docdate',
    key: 'docdate',
    render: (docdate: string) => {
      if (!docdate) return 'N/A'
      const date = dayjs(docdate)
      if (date.isValid()) {
        return date.format('MM/DD/YYYY')
      }
      return 'N/A'
    },
    sorter: {
      compare: (a: EncounterLabApiItem, b: EncounterLabApiItem) => {
        return dayjs(a.docdate).valueOf() - dayjs(b.docdate).valueOf()
      },
      multiple: 1,
    },
  },
]
